import axios from "axios";

const localURL = "http://localhost:3000/api/auth";
const dev_url = "https://sp.bmw.com.tw";
const url = "https://contact.bmw.com.tw";

const userRequest = axios.create( {
    baseURL: process.env.VUE_APP_API
} );
// const headerObj = ( token ) => {
//     return { headers: { Authorization: token } };
// };

const errorHandling = ( err ) => {
    let errObj;
    if ( err.response ) {
        // Request made and server responded
        console.log( err.response.data );
        console.log( err.response.status );
        errObj = err.response.data;
    } else if ( err.request ) {
        // The request was made but no response was received
        console.log( err.request );
        errObj = err.request;
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log( 'Error', err.message );
        errObj = err.message;
    }
    return errObj;
};

userRequest.interceptors.request.use(
    ( config ) => {
        return config;
    },
    ( error ) => {
        const e = errorHandling( error );
        return Promise.reject( e );
    }
);

userRequest.interceptors.response.use(
    ( response ) => {
        return response;
    },
    ( error ) => {
        const e = errorHandling( error );
        return Promise.reject( e );
    }
);

export const apiGetJWTToken = () => userRequest.get( "/api/Jwt/get?username=testdrive&passwd=AMxRM3gNNymg" );
export const apiGetAge = () => userRequest.get( "/api/testdrive/getallage" );
export const apiGetReseller = () => userRequest.get( "/api/testdrive/getallreseller" );
export const apiGetCar = () => userRequest.get( "/api/testdrive/getallbrand" );
export const apiPostReservation = ( data ) => userRequest.post( "/testdrive/process", data, { headers: { "Content-Type": "multipart/form-data" } } );